import Layout from '@/layout';

export default {
  weight: 19,
  path: '/setting',
  component: Layout,
  redirect: '/settingList',
  name: 'setting',
  alwaysShow: true,
  meta: { title: '系统设置', icon: 'el-icon-s-finance' },
  children: [
    {
      path: 'settingList',
      name: 'settingList',
      component: () => import('@/views/setting/searchSetting'),
      meta: { title: '搜索配置', icon: 'el-icon-s-data' },
    },
    {
      path: 'configSetting',
      name: 'configSetting',
      component: () => import('@/views/setting/configSetting'),
      meta: { title: '系统配置', icon: 'el-icon-s-data' },
    },
  ],
};
